<div class="app-header">
  <soq-app-browser-notification-header *ngIf="isBrowserHeaderVisible$ | async" (hide)="hideBrowserHeader()"></soq-app-browser-notification-header>
  <procure-environment-banner
    *ngIf="isEnvironmentBannerEnabled || isBeta"
    [identifier]="isBeta ? 'beta' : environmentInfo.id"
  >
    <ng-container *ngIf="isBeta">
      <b>{{ applicationName }} BETA</b> (Version: {{ environmentInfo.version }})
    </ng-container>
    <ng-container *ngIf="!isBeta">
      Environment: <b>{{ environmentInfo.title }}</b>, Version: <b>{{ environmentInfo.version }}</b>, Build: <b>{{ environmentInfo.buildNumber }}</b>
    </ng-container>
  </procure-environment-banner>
  <div class="app-header__container">
    <div class="app-header__brands">
      <a
        href="https://www.hitachienergy.com"
        draggable="false"
        target="_blank"
        class="app-header__logo-container app-header__logo-container-hitachi-energy"
      >
        <span class="app-header__name logo__img--medium">
          Hitachi Energy
        </span>
      </a>
      <div class="app-header__logo-container app-header__logo-container--app">
        <span class="app-header__name  logo__img--small">
          {{ applicationName }}
        </span>
      </div>
    </div>
    <div class="app-header__brands">
      <a
        href="https://www.hitachi.com"
        target="_blank"
        class="app-header__logo-container app-header__logo-container--hitachi"
      >
        <img
          src="./assets/images/hitachi-global-logo-black.png"
          class="logo__img logo__img--small"
          alt="Hitachi Logo"
        />
      </a>
    </div>
  </div>
</div>
